import React, { ComponentType } from 'react';
import ReactDOM from 'react-dom';
import { setConfig } from 'react-hot-loader';
import './index.scss';
import * as THREE from 'three';

setConfig({
  pureSFC: true,
});

const render = (RootComponent: ComponentType) => {
  ReactDOM.render(<RootComponent />, document.getElementById('react-root'));
};

(async () => {
  const {
    default: Machete,
    // @ts-ignore
  } = await import(
    /* webpackChunkName: "machete-core" */ '@hover/machete-core'
  );
  // @ts-ignore
  window.Machete = Machete;
  // @ts-ignore
  window.Hover = Machete;
  // @ts-ignore
  window.THREE = THREE;
  const { default: Providers } = await import(
    /* webpackChunkName: "main", webpackPreload: true */ 'src/Providers'
  );
  render(Providers);
  // Webpack Hot Module Replacement API
  if (module.hot) {
    module.hot.accept('src/Providers', () => {
      const NewProviders = require('src/Providers').default;
      render(NewProviders);
    });
  }
})();

(async () => {
  // The machete-exporter module is not found by webpack
  // unless it's loaded dynamically like this.
  // @ts-ignore
  const { default: Exporter } = await import(
    /* webpackChunkName: "machete-exporter" */ '@hover/machete-exporter'
  );
})();
